import "core-js/modules/es6.array.map";
import "core-js/modules/es6.object.freeze";
import Color from 'color';
import range from 'lodash/range';
var POWER = Object.freeze({
  linear: 1,
  quadratic: 2,
  cubic: 3,
  quartic: 4
});

var percentageString = function percentageString(num) {
  return num * 100 + "%";
}; // Color's .fade function is a *relative* function,
// where color.fade(0.5) takes rgba(10, 10, 10, 0.8) and returns rgba(10, 10, 10, 0.4)
// we want to transform it into an absolute function
// where absoluteFade(color, 0.5) takes rgba(10, 10, 10, 0.8) and returns rgba(10, 10, 10, 0.3)


var absoluteFade = function absoluteFade(color, amount) {
  var colorObject = Color(color);
  return colorObject.alpha(colorObject.alpha() - amount).string();
};

var gradientStops = function gradientStops(percentages, colors) {
  return range(percentages.length).map(function (stop) {
    return colors[stop] + " " + percentages[stop];
  }).join(', ');
};

var easedGradient = function easedGradient(curve, startPercentage, endPercentage, endOpacity, color) {
  if (startPercentage === void 0) {
    startPercentage = 0;
  }

  if (endPercentage === void 0) {
    endPercentage = 1;
  }

  if (endOpacity === void 0) {
    endOpacity = 1;
  }

  if (color === void 0) {
    color = 'black';
  }

  var power = POWER[curve];
  var numStops = 10;
  var stopPercentageDistance = (endPercentage - startPercentage) / numStops;
  var percentages = range(numStops + 1).map(function (stop) {
    return percentageString(startPercentage + stopPercentageDistance * stop);
  });
  var colors = ['transparent'].concat(range(1, numStops + 1).map(function (stop) {
    return absoluteFade(color, 1 - Math.pow(stop * (1 / numStops), power) * endOpacity);
  }));
  return "linear-gradient(to bottom, " + gradientStops(percentages, colors) + ")";
};

export var gradients = Object.freeze({
  easedGradient: easedGradient
});
export default gradients;